import React from 'react';
import List from '@material-ui/core/List';
import NavigationListItem from './NavigationListItem/NavigationListItem';

const NavigationList = (props) => {
    return (
        <List>
            {props.list.map((item) => (
                <NavigationListItem {...item}/>
            ))}
        </List>
    );
};

export default NavigationList;